/** Per-trip hero banner, rendered from TripDefinition.hero — the travelers/
 * dates line and stops/nights route summary are trip data. The TITLE is the
 * trip's live name: renaming a trip must rename the page header, so the
 * mutable name wins over the extraction-era hero.title snapshot. */
import { esc } from "@trip/shared/engine/time";
import type { HeroDef } from "@trip/shared/types";
import { BRAND, logoLockup } from "./logo.js";

export function heroHTML(hero: HeroDef | undefined, tripName: string): string {
  document.title = tripName ? `${tripName} · ${BRAND}` : BRAND;
  if (!hero) {
    return `<header class="hero"><h1>${esc(tripName)}</h1></header>`;
  }
  const route = hero.route
    .map((seg) => {
      if (seg.via) return esc(seg.via);
      if (seg.stop) return `<b>${esc(seg.stop)}</b>${seg.nights ? ` (${seg.nights} nt${seg.nights > 1 ? "s" : ""})` : ""}`;
      return esc(seg.place || "");
    })
    .join(" ");
  return `<header class="hero">
  <h1>${esc(tripName || hero.title)}</h1>
  <div class="sub">${esc(hero.sub)}</div>
  <div class="route">${route}</div>
</header>`;
}

/** App-generic hero for the login-gated homepage (no trip context yet). */
export function genericHeroHTML(): string {
  document.title = BRAND;
  return `<header class="hero">
  <h1 class="gam-h1">${logoLockup(40)}</h1>
  <div class="sub">Plan together, live — schedules that reflow around real travel time</div>
</header>`;
}
